export const BASE_END_POINT = 'https://wisht7b-api.algorithms.ws/api/v1/' 